import {SimplePresentation, SimplePresentationRunnerController} from "../../../SimplePresentationRunner";
import {XW2GameMode, XwaysHoarder2} from "../../../XwaysHoarder2";
import {gsap} from "gsap";
import {XwaysHoarder2Sound} from "../../../sound/XwaysHoarder2Sound";
import {SymbolStates} from "../../../reels/symbols/BasicSymbol";
import {NormalSymbol} from "../../../reels/symbols/NormalSymbol";
import {XwaysHoarder2Model} from "../../../server/XwaysHoarder2Model";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";


export class BingeSpinBeforeSpinStart implements SimplePresentation {
    name: string = "BingespinBeforeSpinStart";
    private isFs: boolean = false;
    private isSFs: boolean = false;
    private isBinge: boolean = false;

    shouldRun(): boolean {
        this.isFs = XwaysHoarder2Model.isEnteringMode(XwaysHoarder2.model.data, GameMode.FREESPIN);
        this.isSFs = XwaysHoarder2Model.isEnteringMode(XwaysHoarder2.model.data, XW2GameMode.SUPER_FREESPIN);
        this.isBinge = (XwaysHoarder2.model.data.currentFSLevel < 4 && XwaysHoarder2.model.data.nextFSLevel === 4);
        return (XwaysHoarder2.model.data.mode === "NORMAL" && (XwaysHoarder2.model.data.nextMode === "SUPER_FREESPIN") && this.isBinge);
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline();
        controller.setSkipCallback();
        XwaysHoarder2.reelView.symbolsToNormalLayer();
        tl.add(XwaysHoarder2.bonusIntro.showBonusIntro(this.isBinge));
        tl.add(XwaysHoarder2.transitionScreen.enableButton(() => this.onButtonClick(controller)));

    }

    private onButtonClick(controller: SimplePresentationRunnerController) {
        const endIntroTl: gsap.core.Timeline = gsap.timeline();

        endIntroTl.add(XwaysHoarder2.bonusIntro.hideBonusIntro(), 0);//hide Intro view
        endIntroTl.add(XwaysHoarder2.waysCounter.transitionfade(0, 0.05), "<");

        endIntroTl.add(XwaysHoarder2.reelView.hideReels());


        endIntroTl.add(XwaysHoarder2.reelView.showReels());
        //endIntroTl.add(XwaysHoarder2.backgroundElements.backPlateTransition(XwaysHoarder2.model.data.nextMode));
        endIntroTl.add(XwaysHoarder2.waysCounter.transitionfade(1, 0.05), "<");
        endIntroTl.add(XwaysHoarder2.bonusDoors.openGate(XwaysHoarder2.model.data.nextMode));
        if (XwaysHoarder2.model.data.nextFSLevel === 4) {

            /*** REPLACE OTHER SYMS ***/
            const symNames: string [] = ["L1", "L1", "M1", "M2"];
            let cntr: number = 0;

            [0, 5].forEach((rId) => {
                [0, 2].forEach((sId) => {
                    if (rId === 0) {
                        XwaysHoarder2.reelView.reels[rId].replaceSymOnReel(sId, symNames[cntr], true, SymbolStates.NORMAL);
                        //const newSym: NormalSymbol = <NormalSymbol>XwaysHoarder2.reelView.reels[rId].model.getVisibleSymbolAt(sId).positionable;

                    } else {
                        XwaysHoarder2.reelView.reels[rId].replaceSymOnReel(sId, symNames[cntr], true, SymbolStates.NORMAL);
                        //const newSym: NormalSymbol = <NormalSymbol>XwaysHoarder2.reelView.reels[rId].model.getVisibleSymbolAt(sId).positionable;
                    }

                    cntr++;
                });
            });

            /*** REPLACE INTO TRASH SYMS ***/
            //if (!XwaysHoarder2.model.data.reels[0].includes("M3")) {
            XwaysHoarder2.reelView.reels[0].replaceSymOnReel(1, "M3", true, SymbolStates.NORMAL);
            const newSym: NormalSymbol = <NormalSymbol>XwaysHoarder2.reelView.reels[0].model.getVisibleSymbolAt(1).positionable;
            if (newSym.symbolName === "M3") {
                endIntroTl.add(() => {
                    newSym.setSpriteTexture("_binge");
                    newSym.playThrashAnimation();
                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.SYMBOL_REMOVE_CROSS);
                }, ">postTrashAnim");

                endIntroTl.to(this, {duration: 0.5});
            }
            //}
            //if (!XwaysHoarder2.model.data.reels[5].includes("L2")) {
            XwaysHoarder2.reelView.reels[5].replaceSymOnReel(1, "L2", true, SymbolStates.NORMAL);
            const newSym2: NormalSymbol = <NormalSymbol>XwaysHoarder2.reelView.reels[5].model.getVisibleSymbolAt(1).positionable;
            if (newSym2.symbolName === "L2") {
                endIntroTl.add(() => {
                    newSym2.setSpriteTexture("_binge");
                    newSym2.playThrashAnimation();
                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.SYMBOL_REMOVE_CROSS);
                }, ">");
                endIntroTl.to(this, {duration: 1.0});
            }

            //}
            //endIntroTl.add(XwaysHoarder2.fsReelAnimHandler.getTrashAnimation(3, XwaysHoarder2.model.reels));
        }

        endIntroTl.add(() => {
            //controller.setSkipCallback();
            //XwaysHoarder2.fsIndicators.setSpinValue(XwaysHoarder2.model.data.freespinsLeft);
            XwaysHoarder2.keypadPlugin.show(0.2);
            XwaysHoarder2.fsIndicators.hide();

            controller.finish();
        });
    }


}